import { Ref } from 'vue';
import { useI18n } from 'vue-i18n';
import useLPTokenApprovals from '@/composables/farm/useLPTokenApprovals';
import { TransactionActionInfo } from '@/types/transactions';

export default function useTokenApprovalActions(
  tokenAddresses: string[],
  amounts: Ref<string[]>
) {
  const { t } = useI18n();
  const { requiredApprovalState, approveToken } = useLPTokenApprovals(
    tokenAddresses,
    amounts
  );

  const tokenApprovalActions: TransactionActionInfo[] = Object.keys(
    requiredApprovalState.value
  ).map(address => {
    return {
      label: 'Approve LP Token for staking',
      loadingLabel: t('investment.preview.loadingLabel.approval'),
      confirmingLabel: t('confirming'),
      stepTooltip:
        'You must approve LP to stake this token on Hexagon. Approvals are required once per token, per wallet.',
      action: () => {
        return approveToken(address);
      }
    };
  });

  return {
    tokenApprovalActions
  };
}
